import { createBrowserRouter } from "react-router-dom";
import HomePage from "../../features/presentation/page/home/home_page";
import LoginPage from "../../features/presentation/page/login/login_page.js";
import CreateAccountPage from "../../features/presentation/page/createaccount/create_account_page.js";
import DashboardPage from "../../features/presentation/page/dashboard/dashboard_page.js";
import OtpPage from "../../features/presentation/page/otp/otp_page.js";
import {
  InitialRoute,
  HomeRoute,
  LoginRoute,
  CreateAccountRoute,
  DashboardRoute,
  OtpRoute,
  ContactUsRoute,
  SubmitFeedbackRoute,
  PrivacyPolicyRoute,
  ForgotPasswordRoute,
  ResetPasswordRoute,
  InitRoute,
  SignUpRoute,
  StartExperienceRoute,
  VideoChatRoute,
  TermsOfServiceRoute,
  ModelProfileRoute,
  EveProfileRoute,
  PaymentRoute,
  Statement2257Route,
  ComplaintsPolicyRoute,
  ContentRemovalPolicyRoute,
} from "./route_constants.js";
import WithUserProtection from "./middleware/with_user_protection.js";
import WithoutUserProtection from "./middleware/without_user_protection.js";
import InitialRouteMiddleWare from "./middleware/initial_route_middleware.js";
import ContactUsPage from "../../features/presentation/page/contactus/contact_us_page.js";
import SubmitFeedbackPage from "../../features/presentation/page/submitfeedback/submit_feedback_page.jsx";
import PrivacyPolicyPage from "../../features/presentation/page/privacypolicy/privacy_policy_page.jsx";
import NotFoundPage from "../../features/presentation/page/notfound/not_found_page.jsx";
import ForgotPasswordPage from "../../features/presentation/page/forgotpassword/forgot_password_page.jsx";
import ResetPasswordPage from "../../features/presentation/page/resetpassword/reset_password_page.jsx";
import InitPage from "../../features/presentation/page/init/init_page.js";
import HomeV2Page from "../../features/presentation/page/home_v2/home_v2_page.jsx";
import LoginV2Page from "../../features/presentation/page/login_v2/login_v2_page.jsx";
import VideoChatPage from "../../features/presentation/page/video_chat/video_chat_page.js";
import StartExperiencePage from "../../features/presentation/page/startexperience/start_experience_page.jsx";
import SignUpPage from "../../features/presentation/page/signup/sign_up_page.jsx";
import TermsOfServicePage from "../../features/presentation/page/termsandservice/terms_of_service_page.jsx";
import ModelProfilePage from "../../features/presentation/page/modelprofile/model_profile_page.jsx";
import PaymentPage from "../../features/presentation/page/payment/payment_page.jsx";
import Statement2257Page from "../../features/presentation/page/2257statement/2257_statement_page.jsx";
import ComplaintsPolicyPage from "../../features/presentation/page/complaintspolicy/complaints_policy_page.jsx";
import ContentRemovalPolicyPage from "../../features/presentation/page/contentremovalpolicy/content_removal_policy_page.jsx";

export const router = createBrowserRouter([
  {
    element: <InitialRouteMiddleWare />,
    children: [
      { path: InitialRoute, element: <HomeV2Page /> },
      { path: HomeRoute, element: <HomeV2Page /> },
      { path: ContactUsRoute, element: <ContactUsPage /> },
      { path: PrivacyPolicyRoute, element: <PrivacyPolicyPage /> },
      { path: TermsOfServiceRoute, element: <TermsOfServicePage /> },
      { path: ModelProfileRoute, element: <ModelProfilePage /> },
      { path: EveProfileRoute, element: <ModelProfilePage /> },
      { path: Statement2257Route, element: <Statement2257Page /> },
      { path: ComplaintsPolicyRoute, element: <ComplaintsPolicyPage /> },
      { path: ContentRemovalPolicyRoute, element: <ContentRemovalPolicyPage /> },
    ],
  },
  {
    element: <WithoutUserProtection />,
    children: [
      { path: LoginRoute, element: <LoginV2Page /> },
      { path: CreateAccountRoute, element: <CreateAccountPage /> },
      { path: OtpRoute, element: <OtpPage /> },
      { path: ForgotPasswordRoute, element: <ForgotPasswordPage /> },
      { path: `${ResetPasswordRoute}/:token`, element: <ResetPasswordPage /> },
      { path: StartExperienceRoute, element: <StartExperiencePage /> },
      { path: SignUpRoute, element: <SignUpPage /> },
    ],
  },
  {
    element: <WithUserProtection />,
    children: [
      { path: InitRoute, element: <InitPage /> },
      { path: `${DashboardRoute}/:tab?`, element: <DashboardPage /> },
      { path: SubmitFeedbackRoute, element: <SubmitFeedbackPage /> },
      { path: `${PaymentRoute}/:transactionType/:transactionId/:from?`, element: <PaymentPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
  { path: `${VideoChatRoute}/:chatChannelId`, element: <VideoChatPage /> },
]);
